<template>
  <div style="margin-top:0px;">
    <!-- As a heading -->
    <div style="margin-top:0px;">
      
      <b-container class="bv-example-row">
        <b-row>
          <b-col sm='4'></b-col>
          <b-col sm='4'>
               <h1 class="ml12">
                 <a id="topName"><span class="myblink">Sonic</span> Digital <span id="someId" @click="addClass" :class="[addNow?'myblink2':'']">Art</span></a>
                </h1>
          </b-col>
          <b-col sm='4'></b-col>
        </b-row>
      </b-container>
      
    </div>
  </div>
  
</template>

<script>
export default {
  props: {
    loadHome:Function,
  },
  data(){
    return{
      addNow:false,
    }
  },
  methods:{
    addClass:function(){
        this.addNow=true;
        setTimeout(()=>{
        this.loadHome(this.addNow);
        },1000);
    }
  },
  mounted(){
    document.getElementById('someId').click();
  }

}
     
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  html,body
{
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
    overflow-x: hidden; 
}
  .ml12 {
      font-weight: 200;
      font-size: 1em;
      text-transform: uppercase;
      letter-spacing: 0.5em;
     
		}
    .myblink{
       -webkit-animation: 0.2s linear 4 condemned_blink_effect; /* for Safari 4.0 - 8.0 */
      animation: 0.2s linear 4 condemned_blink_effect;
    }
    .myblink2{
       -webkit-animation: 0.5s linear 2 condemned_blink_effect; /* for Safari 4.0 - 8.0 */
      animation: 0.5s linear 2 condemned_blink_effect;
    }
   


    @-webkit-keyframes condemned_blink_effect { 
        0% {
          visibility: hidden;
        }
        50% {
          visibility: hidden;
        }
        100% {
          visibility: visible;
        }
      }

      @keyframes condemned_blink_effect {
        0% {
          visibility: hidden;
        }
        50% {
          visibility: hidden;
        }
        100% {
          visibility: visible;
        }
      }
  



</style>
